import ReactDOM from 'react-dom';
import { PropsWithChildren, ReactPortal } from 'react';

export interface PortalProps {
  /** The container where content should be rendered */
  container?: HTMLElement;
}

const getSSRSafeContainer = () => (typeof document === 'undefined' ? undefined : document?.body);

function Portal({ children, container }: PropsWithChildren<PortalProps>): ReactPortal {
  // @ts-ignore
  return ReactDOM.createPortal(children, container || getSSRSafeContainer());
}

export default Portal;
